import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { tv } from 'tailwind-variants';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Badge',
    props: {
        color: {},
        type: {},
        className: {}
    },
    setup(__props) {
        const props = __props;
        const badge = tv({
            base: 'text-caption-2 desktop:text-caption-1 flex w-fit items-center py-2',
            variants: {
                color: {
                    blue: 'bg-blue-150 text-blue-700',
                    gray: 'bg-gray-200 text-gray-800',
                    coral: 'bg-coral-150 text-coral-700',
                    yellow: 'bg-yellow-150 text-yellow-700',
                    teal: 'bg-teal-150 text-teal-700',
                    green: 'bg-green-150 text-green-700',
                    violet: 'bg-violet-150 text-violet-700',
                },
                type: {
                    outlined: 'rounded-12 border bg-transparent px-8',
                    filled: 'rounded-4 px-6',
                },
            },
            compoundVariants: [
                {
                    color: 'gray',
                    type: 'outlined',
                    class: 'border-gray-400 text-gray-500',
                },
                {
                    color: 'blue',
                    type: 'outlined',
                    class: 'border-blue-600 text-blue-600',
                },
            ],
            defaultVariants: {
                color: 'blue',
                type: 'filled',
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(_unref(badge)({
                    color: props.color,
                    type: props.type,
                    class: props.className,
                }))
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 2));
        };
    }
});
